<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Privacy
        </h3>
        <p class="text--secondary">
          Control your privacy settings and data sharing preferences.
        </p>
      </v-col>
    </v-row>

    <!-- Data Sharing -->
    <v-card
      outlined
      class="mb-4"
    >
      <v-card-text>
        <div class="text-subtitle-2 font-weight-bold mb-3">
          <font-awesome-icon
            :icon="['fas', 'share-nodes']"
            class="mr-2"
          />
          Data Sharing
        </div>

        <v-row
          align="center"
          class="my-1"
        >
          <v-col>
            <div class="text-body-2">
              Share usage data
            </div>
            <div class="caption text--secondary">
              Help improve iAdOps by sharing anonymous usage statistics
            </div>
          </v-col>
          <v-col class="col-auto">
            <v-switch
              :input-value="localPrivacy.shareUsageData"
              color="primary"
              hide-details
              @change="localPrivacy.shareUsageData = $event"
            />
          </v-col>
        </v-row>

        <v-row
          align="center"
          class="my-1"
        >
          <v-col>
            <div class="text-body-2">
              Allow analytics
            </div>
            <div class="caption text--secondary">
              Allow us to collect analytics data to improve your experience
            </div>
          </v-col>
          <v-col class="col-auto">
            <v-switch
              :input-value="localPrivacy.allowAnalytics"
              color="primary"
              hide-details
              @change="localPrivacy.allowAnalytics = $event"
            />
          </v-col>
        </v-row>

        <v-row
          align="center"
          class="my-1"
        >
          <v-col>
            <div class="text-body-2">
              Share profile data
            </div>
            <div class="caption text--secondary">
              Share your profile information with team members
            </div>
          </v-col>
          <v-col class="col-auto">
            <v-switch
              :input-value="localPrivacy.shareProfileData"
              color="primary"
              hide-details
              @change="localPrivacy.shareProfileData = $event"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row class="mt-4">
      <v-col class="d-flex justify-end">
        <v-btn
          color="primary"
          :disabled="!hasChanges"
          :loading="loading"
          @click="handleSubmit"
        >
          <font-awesome-icon
            :icon="['fas', 'floppy-disk']"
            class="mr-2"
          />
          Save Privacy Settings
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const defaultPrivacy = {
  shareUsageData: false,
  allowAnalytics: true,
  shareProfileData: false,
}

export default {
  name: 'SettingsPrivacy',
  props: {
    privacy: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localPrivacy: { ...defaultPrivacy },
    }
  },
  computed: {
    hasChanges() {
      return JSON.stringify(this.localPrivacy) !== JSON.stringify(this.mergedPrivacy)
    },
    mergedPrivacy() {
      return { ...defaultPrivacy, ...this.privacy }
    },
  },
  watch: {
    privacy: {
      handler() {
        this.localPrivacy = { ...this.mergedPrivacy }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      if (this.hasChanges) {
        this.$emit('update', this.localPrivacy)
      }
    },
  },
}
</script>
